module.exports = __webpack_public_path__ + "88554d3759c16f1c71b615e916e3f54e.pdf";